import { useLocation, useMatches } from 'react-router-dom';

export function useCurrentMatch(): string | null {
  const matches = useMatches();
  const location = useLocation();
  const match = matches.find((match) => match.pathname === location.pathname);

  if (!match) {
    return null;
  }

  let matchPath = match.pathname;

  for (const param in match.params) {
    matchPath = matchPath.replace(
      (match.params as Record<string, string>)[param],
      `:${param}`,
    );
  }

  return matchPath;
}
